import script from "./TheAppHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./TheAppHeader.vue?vue&type=script&setup=true&lang=ts"

import "./TheAppHeader.vue?vue&type=style&index=0&id=1522c640&scoped=true&lang=scss"
import "./TheAppHeader.vue?vue&type=style&index=1&id=1522c640&lang=scss"

import exportComponent from "/home/runner/work/EthVM/EthVM/v2/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.75.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1522c640"]])

export default __exports__